export default "__VITE_ASSET__0rUqXpbS__"